<div class="grid align-center vertical-container">
  <div class="col-12">
    <div class="box">
      <div class="brand-bar"></div>
      <app-school-list
        [headerText]="headerText"
        (schoolChanged)="schoolChange($event)"
      ></app-school-list>
    </div>
  </div>
</div>

<div class="grid">
  <div class="col">
    <button
      pButton
      type="button"
      (click)="showCreateUserDialog()"
      label="Add New User"
      class="button-custom float-right"
      #buttonAddNewUser
    ></button>
  </div>
</div>
<p-table
  [value]="filteredUsers"
  class="checkboxSelectionTable"
  dataKey="userId"
  editMode="row"
  selectionMode="single"
  #allUsers
>
  <ng-template pTemplate="header">
    <tr>
      <th
        class="align-left width-fifteen"
        [pSortableColumn]="'firstName'"
        scope="col"
      >
        First Name<p-sortIcon [field]="'firstName'"> </p-sortIcon>
      </th>
      <th
        class="align-left width-fifteen"
        [pSortableColumn]="'familyName'"
        scope="col"
      >
        Last Name<p-sortIcon [field]="'familyName'"> </p-sortIcon>
      </th>
      <th class="align-left width-thirty" scope="col">Email Address</th>
      <th class="align-center width-eight" scope="col">Active</th>
      <th
        class="align-left width-twenty-two"
        [ariaHidden]="true"
        scope="col"
      ></th>
      <th class="align-left width-ten" [ariaHidden]="true" scope="col"></th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-user
    let-editing="editing"
    let-ri="rowIndex"
  >
    <tr
      [pEditableRow]="user"
      class="overflow-wrap vertical-align-top"
      [pSelectableRow]="filteredUsers"
      (focus)="isFocusOnRow = true"
      (blur)="isFocusOnRow = false"
      (keydown.enter)="editRowData(ri)"
    >
      <td class="align-left width-fifteen">
        <div>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                class="full-width"
                pInputText
                type="text"
                [(ngModel)]="user.firstName"
                pattern=".*\S+.*"
                required
                attr.ri="{{ ri }}"
                #firstName="ngModel"
                aria-label="First Name"
              />
              @if (
                firstName.invalid && (firstName.dirty || firstName.touched)
              ) {
                <div class="error-label">
                  @if (firstName.errors.required) {
                    <div>First Name is required</div>
                  }
                  @if (firstName.errors.pattern) {
                    <div>Invalid characters</div>
                  }
                </div>
              }
            </ng-template>
            <ng-template pTemplate="output">
              {{ user.firstName }}
            </ng-template>
          </p-cellEditor>
        </div>
      </td>
      <td class="align-left width-fifteen">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input
              class="full-width"
              pInputText
              type="text"
              [(ngModel)]="user.familyName"
              required
              pattern=".*\S+.*"
              #familyName="ngModel"
              aria-label="Family Name"
            />
            @if (
              familyName.invalid && (familyName.dirty || familyName.touched)
            ) {
              <div class="error-label">
                @if (familyName.errors.required) {
                  <div>Last Name is required</div>
                }
                @if (familyName.errors.pattern) {
                  <div>Invalid characters</div>
                }
              </div>
            }
          </ng-template>
          <ng-template pTemplate="output">
            {{ user.familyName }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td class="align-left width-thirty">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input
              class="full-width"
              pInputText
              type="text"
              [(ngModel)]="user.email"
              email
              #email="ngModel"
              aria-label="Email"
              coreDuplicateFieldValidator
              [params]="emailValidationParams"
              required
              [ngModelOptions]="{ updateOn: 'blur' }"
            />
            @if (email.invalid && (email.dirty || email.touched)) {
              <div class="error-label">
                @if (email.errors.required) {
                  <div>Email Address is required</div>
                }
                @if (email.errors.email) {
                  <div>Provide a valid Email Address</div>
                }
              </div>
            }
            @if (email.dirty && email?.errors?.duplicateValue) {
              <div class="error-label">
                A user already exists with this Email Address
              </div>
            }
          </ng-template>
          <ng-template pTemplate="output">
            {{ user.email }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td class="align-center width-eight padding-top-10">
        @if (isLAUser()) {
          <p-checkbox
            value="Status"
            ariaLabel="Status"
            (onChange)="changeStatus(user)"
            [(ngModel)]="user.localAuthority.active"
            binary="true"
          ></p-checkbox>
        }

        @if (isSchoolUser()) {
          <p-checkbox
            value="Status"
            ariaLabel="Status"
            (onChange)="changeStatus(user)"
            [(ngModel)]="user.schools[0].active"
            binary="true"
          ></p-checkbox>
        }
      </td>
      <td class="width-twenty-two button-save-zoom-support">
        @if (!editing) {
          <button
            pButton
            type="button"
            pInitEditableRow
            icon="pi pi-pencil"
            title="Edit User Details"
            class="ui-button-info"
            (click)="onRowEditInit(user, ri)"
          ></button>
        }
        @if (editing) {
          <button
            pButton
            type="button"
            [disabled]="disableSaveButton(user)"
            pSaveEditableRow
            icon="pi pi-check"
            class="ui-button-success margin-right-custom"
            (click)="onRowEditSave(user, ri)"
            title="Save User Details"
          ></button>
        }
        @if (editing) {
          <button
            pButton
            type="button"
            pCancelEditableRow
            icon="pi pi-times"
            class="ui-button-danger"
            (click)="onRowEditCancel(user, ri)"
            title="Cancel User Details"
          ></button>
        }
      </td>
      <td class="align-left width-ten">
        @if (isLAUser() && user.localAuthority.active) {
          <button
            (click)="onSendEmail(user)"
            pButton
            type="button"
            icon="pi pi-envelope"
            title="Resend Welcome Email"
            class="ui-button-info"
          ></button>
        }
        @if (isSchoolUser() && user.schools[0].active) {
          <button
            (click)="onSendEmail(user)"
            pButton
            type="button"
            icon="pi pi-envelope"
            title="Resend Welcome Email"
            class="ui-button-info"
          ></button>
        }
      </td>
    </tr>
  </ng-template>
</p-table>
<p-dialog
  #dialogAddNewUser
  header="Add New User"
  [(visible)]="display"
  [modal]="true"
  styleClass="mydialog"
  (onHide)="setFocusOnAddNewUserButton()"
>
  <form [formGroup]="userFields">
    <div class="required-field-disclaimer padding-bottom-a-rem">
      Mandatory fields are marked with a red asterisk <span class="red">*</span>
    </div>
    <div class="grid">
      <div class="col-6">
        <label class="float-left margin-bottom-half-rem" for="FirstName"
          >First Name <span class="error-label">*</span></label
        >
        <div>
          <input
            [class.is-invalid]="f.FirstName.invalid && f.FirstName.touched"
            type="text"
            class="form-control input-border full-width"
            formControlName="FirstName"
            id="FirstName"
            pInputText
            autofocus
          />
        </div>
        @if (
          (f.FirstName.invalid && f.FirstName.touched) || f.FirstName.dirty
        ) {
          <div class="float-left">
            @if (f.FirstName.errors?.required) {
              <small class="error-label">First Name is required</small>
            }
            @if (f.FirstName.errors?.pattern) {
              <small class="error-label">Invalid characters</small>
            }
          </div>
        }
      </div>
      <div class="col-6">
        <label class="float-left margin-bottom-half-rem" for="FamilyName"
          >Last Name <span class="error-label">*</span></label
        >
        <div>
          <input
            [class.is-invalid]="f.FamilyName.invalid && f.FamilyName.touched"
            type="text"
            class="input-border full-width"
            formControlName="FamilyName"
            id="FamilyName"
            pInputText
          />
        </div>
        @if (
          (f.FamilyName.invalid && f.FamilyName.touched) || f.FamilyName.dirty
        ) {
          <div class="float-left">
            @if (f.FamilyName.errors?.required) {
              <small class="error-label">Last Name is required</small>
            }
            @if (f.FamilyName.errors?.pattern) {
              <small class="error-label">Invalid characters</small>
            }
          </div>
        }
      </div>
      <div class="col-12 padding-zero">
        <div class="col-6">
          <label class="float-left margin-bottom-half-rem" for="Email"
            >Email Address <span class="error-label">*</span></label
          >
          <div>
            <input
              [class.is-invalid]="f.Email.invalid && f.Email.touched"
              type="email"
              class="form-control input-border full-width"
              formControlName="Email"
              id="Email"
              pInputText
            />
          </div>
          @if ((f.Email.invalid && f.Email.touched) || f.Email.dirty) {
            <div class="float-left">
              @if (f.Email.errors?.required) {
                <small class="error-label">Email Address is required</small>
              }
              @if (f.Email.errors?.email) {
                <small class="error-label"
                  >Please provide a valid Email Address</small
                >
              }
              @if (f.Email.errors?.duplicateValue) {
                <small class="error-label">
                  A user already exists with this Email Address
                </small>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="grid flex-row-reverse">
      <button
        pButton
        type="button"
        class="margin-right"
        (click)="saveuser()"
        label="Save"
        [disabled]="isSaveClicked"
      ></button>
      <button
        pButton
        type="button"
        class="margin-right"
        (click)="closePopup()"
        label="Cancel"
      ></button>
    </div>
  </form>
</p-dialog>
